import { render } from 'solid-js/web'
import { Router } from '@solidjs/router'
import App from './App'
import './styles.css'

// Error boundary for debugging
try {
  render(
    () => (
      <Router>
        <App />
      </Router>
    ),
    document.getElementById('root')!,
  )
} catch (err) {
  console.error('App mount failed:', err)
  document.getElementById('root')!.innerHTML = `<div style="padding:2rem;color:red;">
    <h1>Error loading app</h1>
    <pre>${err instanceof Error ? err.message : String(err)}</pre>
  </div>`
}
